import { searchLocationWithData } from './searchLocationHelper';

const updateFilterOptions = (location: string, geoLocation: any, setFilterOptions: any) => {
  if (!geoLocation) {
    return null;
  }

  const slugInfo = searchLocationWithData(location, geoLocation);

  // Common base structure for filter updates
  const baseUpdate = (prev: any) => ({
    ...prev,
    country: null,
    state: null,
    city: null,
  });

  // Handle special 'abroad' case first
  if (location === 'abroad') {
    setFilterOptions((prev: any) => ({
      ...baseUpdate(prev),
      country: {
        id: null,
        country_name: 'Abroad',
        country_url: 'study-in-abroad',
      },
    }));
    return;
  }

  // Return early if no valid slug info
  if (!slugInfo?.type) return;

  // Create location object based on type
  const locationUpdate = {
    country: slugInfo.country_name
      ? {
          id: null,
          country_name: slugInfo.country_name,
          country_url: slugInfo.country_url,
        }
      : null,

    state: slugInfo.state_name
      ? {
          id: null,
          state_name: slugInfo.state_name,
          state_url: slugInfo.state_url,
        }
      : null,

    city: slugInfo.city_name
      ? {
          id: null,
          city_name: slugInfo.city_name,
          city_url: slugInfo.city_url,
        }
      : null,
  };

  // Clear child locations when parent is selected
  switch (slugInfo.type) {
    case 'country':
      locationUpdate.state = null;
      locationUpdate.city = null;
      break;

    case 'state':
      locationUpdate.city = null;
      break;

    case 'city':
      // Keep all location data
      break;
  }

  setFilterOptions((prev: any) => ({
    ...baseUpdate(prev),
    ...locationUpdate,
  }));
};

export default updateFilterOptions;
